import { jsx as _jsx } from "react/jsx-runtime";
export default function DescriptionField({ id, description }) {
    if (description) {
        return (_jsx("div", { children: _jsx("div", { id: id, className: 'mb-3', children: description }) }));
    }
    return null;
}
//# sourceMappingURL=DescriptionField.js.map